import Card from '../../../../shared/types/props/card';
import Container from '../../atoms/container/squareItemContainer';
import Focus from '../../atoms/focus/squareCardListFocus';
import Image from '../../atoms/images/squareImage';
import MainContext from '../../../../shared/components/utils/context/mainContext';
import useList from '../../../../shared/components/utils/hooks/useList';
import { magicRemoteSelector } from '../../../../shared/store/slices/magicRemote.slice';
import { useAppSelector } from '../../../../shared/store/hooks';
import { useContext } from 'react';

function SquareCard({ item, index, onClick }: Card) {
  const { enabled } = useAppSelector(magicRemoteSelector);
  const { hidePreviousItem, setAsset } = useContext(MainContext);
  const { distanceToIndex, focused, fixed, listIndex } = useList(index);

  const displayBorders = fixed || !hidePreviousItem || distanceToIndex > -1;
  const displayCard = fixed || distanceToIndex < 20;
  const displayFocus = !enabled && focused && fixed && listIndex === index;
  const displayImage = fixed || distanceToIndex > (hidePreviousItem ? -1 : -20);

  return (
    <>
      {displayCard ? (
        <Container
          borders={displayBorders}
          onClick={onClick}
          onMouseEnter={() => setAsset(item)}
        >
          {displayImage ? <Image src={item?.channel?.logo} /> : null}
          {displayFocus ? <Focus fixed /> : null}
        </Container>
      ) : null}
    </>
  );
}

export default SquareCard;
